import React from "react"
import style from "./sidebar.module.scss"
var classNames = require("classnames");

type SidebarState = { picture: PictureInfo | null, closed: boolean, imageSrc: string | undefined | null, isOnTheLeft: boolean}

class Sidebar extends React.Component<{}, SidebarState> {
  data: any;
  constructor(props: any)
  {
    super(props);
    this.state = {picture: null, closed: true, imageSrc: null, isOnTheLeft: false};
    this.setPicture = this.setPicture.bind(this);
    this.close = this.close.bind(this);
  }

  setPicture(picture: PictureInfo, src: string, left: boolean) {
    this.setState({ picture, closed: false, imageSrc: src, isOnTheLeft: left });
  }

  close() {
    this.setState(({picture}) => ({picture, closed: true}));
  }

  render() {
    let classes = {};
    classes[style.sidebar] = true;
    classes[style.sidebarEnableTransition] = this.state.picture != null;
    classes[style.sidebarHiddenLeft] = this.state.closed && this.state.isOnTheLeft;
    classes[style.sidebarHiddenRight] = this.state.closed && !this.state.isOnTheLeft;
    classes[style.sidebarLeft] = this.state.isOnTheLeft;
    classes[style.sidebarRight] = !this.state.isOnTheLeft;
    return (
      <div className={classNames(classes)}>
        <img src="/icons/close-icon-1.png" className={style.closeButton} onClick={this.close} draggable={false}/>
        <div className={style.container}>
          { (this.state.picture?.description != null && this.state.picture?.description !== "") ?
            <>
              <p>{this.state.picture?.description}</p>
              <hr className={style.divider} />
            </>
            : <></>
          }
          <p className={style.subheading}>Command: </p>
          <code>{this.state.picture?.cmdline}</code>
          <a className={style.fullImageLink} href={this.state.imageSrc} target="_blank">View full image</a>
        </div>
      </div>
    );
  }

}

export default Sidebar;